@if (trophies()) {
  <div class="recurring-hall-container">
    @for (row of rows(); track $index) {
      <div class="hall-row">
        @for (item of row; track item) {
          <slotcom-hall-item
            [trophy]="item.trophy"
            [total]="item.total"></slotcom-hall-item>
        }
      </div>
    }
  </div>
}
